/* eslint-disable radix */
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import _get from 'lodash/get';
import { withLDConsumer } from 'launchdarkly-react-client-sdk';
import { extractUniqueTags } from '@btag/bt-personalization';

import updateAllPadding from '../updateAllPadding';
import emitter from '../../../../common/eventService/emitter';
import ElementPadding from '../../../../componentLibrary/ElementPadding';
import HorizontalRule from '../../../../componentLibrary/HorizontalRule';
import Modal from '../../../../componentLibrary/Modal';
import BananatagButton from '../../../../componentLibrary/BananatagButton';
import imageSources from '../../../../constants/imageSources/imageSources';
import TagPanel from '../../Personalization/TagPanel';
import paddingChange from '../../paddingChange';
import * as columnItemActions from '../../../../actions/columnItem';
import * as Styled from '../styles';
import ParagraphButtonMenu from './ParagraphButtonMenu';
import HTMLEditMessage from '../HTMLEditMessage';
import { blockType, elementContentType } from '../../../../types';
import handleKeyPress from '../../../../common/handleKeyPress';

class ParagraphSetting extends PureComponent {
    state = {
        blockIndex: null,
        columnIdx: null,
        elmIdx: null,
        content: null,
        showSourceEditor: false,
        showInfoMessage: false,
        contentValues: {
            textMarkupValue: '',
            align: '',
            fontFamily: '',
            fontSize: '',
            lineHeight: '',
            paddingTop: 0,
            paddingRight: 0,
            paddingBottom: 0,
            paddingLeft: 0,
        },
    };

    static getDerivedStateFromProps(nextProps, prevState) {
        const { selectedElementData } = nextProps;
        const { blockIndex, columnIdx, elmIdx, content } = selectedElementData;
        const {
            textMarkupValue,
            align,
            fontFamily,
            fontSize,
            lineHeight,
            paddingTop,
            paddingRight,
            paddingBottom,
            paddingLeft,
        } = content;
        const contentValues = {
            textMarkupValue,
            align,
            fontFamily,
            fontSize,
            lineHeight,
            paddingTop,
            paddingRight,
            paddingBottom,
            paddingLeft,
        };

        const propsChanged =
            elmIdx !== prevState.elmIdx || JSON.stringify(contentValues) !== JSON.stringify(contentValues.prevState);
        if (propsChanged) {
            return { ...prevState, elmIdx, blockIndex, columnIdx, content, contentValues };
        }
        return { ...prevState };
    }

    _updateContent(key, value) {
        const { blockIndex, columnIdx, elmIdx, content, contentValues } = this.state;
        const { dispatch } = this.props;
        let newContentValues;
        if (key === 'fontSize') {
            newContentValues = { ...contentValues, [key]: value, lineHeight: value };
        } else if (key === 'updateAllPadding') {
            newContentValues = updateAllPadding(contentValues, value);
        } else {
            newContentValues = { ...contentValues, [key]: value };
        }
        const newContent = { ...content, ...newContentValues };
        dispatch(columnItemActions.updateColumnItemContent({ blockIndex, columnIdx, elmIdx, newContent }));
        this.setState((prevState) => ({
            ...prevState,
            contentValues: newContentValues,
        }));
    }

    // This function checks if the feature flag is enabled, if it is then it will check for isTable.
    _shouldRenderSidebarContent() {
        const { isTable } = this.props;

        if (isTable) {
            return false;
        }

        return true;
    }


    render() {
        const { elmIdx, contentValues, showSourceEditor, content, showInfoMessage } = this.state;
        const { blocks, sessionFeatures, hasPersonalization, flags } = this.props;
        const { F_EDIT_HTML, F_ELEMENT_TOC } = sessionFeatures;
        const { paddingTop, paddingRight, paddingBottom, paddingLeft } = contentValues;
        const tocButtons = [
            {
                icon: imageSources.ICONS.LIST_ICON,
                text: 'List Format',
                onClick: () =>
                    F_ELEMENT_TOC
                        ? emitter.emit(`GENERATE_TABLE_OF_CONTENTS-${elmIdx}`, { type: 'list', blocks })
                        : null,
                dataTestId: 'table-of-content-list',
                tooltipText: F_ELEMENT_TOC
                    ? ''
                    : 'Table of Contents provide shortcuts to other sections of the draft. Learn more with a demo.',
                cursor: F_ELEMENT_TOC ? 'pointer' : 'not-allowed',
            },
            {
                icon: imageSources.ICONS.MENU_ICON,
                text: 'Menu Format',
                onClick: () =>
                    F_ELEMENT_TOC
                        ? emitter.emit(`GENERATE_TABLE_OF_CONTENTS-${elmIdx}`, { type: 'menu', blocks })
                        : null,
                dataTestId: 'table-of-content-menu',
                tooltipText: F_ELEMENT_TOC
                    ? ''
                    : 'Table of Contents provide shortcuts to other sections of the draft. Learn more with a demo.',
                cursor: F_ELEMENT_TOC ? 'pointer' : 'not-allowed',
            },
        ];

        return (
            <>
                {showSourceEditor && (
                    <Modal
                        dataTestId="edit-html-modal"
                        width={600}
                        height={549}
                        labelledBy="edit-html-modal-title"
                        onEsc={() => {
                            this.setState({ showSourceEditor: false });
                        }}
                    >
                        <Styled.CloseButtonWrapper
                            onClick={() => {
                                this.setState({ showSourceEditor: false });
                            }}
                            onKeyDown={(e) =>
                                handleKeyPress(e, () => {
                                    this.setState({ showSourceEditor: false });
                                })
                            }
                            role="button"
                            tabIndex="0"
                            aria-label="close modal"
                        >
                            <Styled.CloseIcon icon="times" aria-hidden />
                        </Styled.CloseButtonWrapper>
                        <Styled.SourceEditorBody>
                            <Styled.ModalHeader>
                                HTML MODE
                                <Styled.InfoIcon
                                    icon="exclamation-circle"
                                    onMouseOver={() => this.setState({ showInfoMessage: true })}
                                    onMouseLeave={() => this.setState({ showInfoMessage: false })}
                                />
                            </Styled.ModalHeader>
                            {showInfoMessage && (
                                <Styled.InfoBlock>
                                    <Styled.InfoHeader>Supported HTML Code: </Styled.InfoHeader>
                                    <Styled.InfoBody>
                                        <Styled.SecondaryHeader>ELEMENT TAGS</Styled.SecondaryHeader>
                                        {
                                            '<a>  <strong>  <ul>  <ol>  <li> <h1>  <h2>  <h3>  <p> <span>  <em>  <ins>  <sub>  <sup> <del>'
                                        }
                                        <Styled.SecondaryHeader>ELEMENT ATTRIBUTES</Styled.SecondaryHeader>
                                        ‘style,’ ‘href’, ‘target’, ‘src’
                                        <Styled.SecondaryHeader>INLINE CSS</Styled.SecondaryHeader>
                                        ‘color’, ‘background-color’, ‘font-size‘
                                    </Styled.InfoBody>
                                </Styled.InfoBlock>
                            )}
                        </Styled.SourceEditorBody>
                        <Styled.SourceEditor data-test-id="edit-html-content" id="source-code">
                            {content.textMarkupValue}
                        </Styled.SourceEditor>
                        <Styled.ModalButtons>
                            <BananatagButton
                                onClick={() => {
                                    this.setState({ showSourceEditor: false });
                                }}
                                styling={{ marginRight: 5 }}
                                text="cancel"
                                type="clear"
                                size="medium"
                            />
                            <BananatagButton
                                onClick={() => {
                                    const html = document.getElementById('source-code').value;
                                    emitter.emit(`EDIT_SOURCE_CODE-${elmIdx}`, html);
                                    this.setState({ showSourceEditor: false });
                                }}
                                text="Update"
                                type="solid"
                                size="medium"
                            />
                        </Styled.ModalButtons>
                    </Modal>
                )}
                <Styled.Row>
                    {this._shouldRenderSidebarContent() && (
                        <>
                            <ElementPadding
                                paddingTop={paddingTop}
                                paddingBottom={paddingBottom}
                                paddingLeft={paddingLeft}
                                paddingRight={paddingRight}
                                elementType="paragraph"
                                onChange={(event) => {
                                const payload = paddingChange({
                                    event,
                                    paddingBottom,
                                    paddingLeft,
                                    paddingRight,
                                    paddingTop,
                                });
                                if (!payload) {
                                    return;
                                }
                                    const { key, value = 0 } = payload;
                                    this._updateContent(key, value);
                                }}
                            />
                            <HorizontalRule />
                            <ParagraphButtonMenu buttons={tocButtons} label="table of contents" dataTestId="table-of-content" />
                            <HorizontalRule styling={{ marginTop: 16 }} />
                        </>
                    )}
                    {flags.ed484PersonalizationMsft && hasPersonalization &&
                        <TagPanel tagsInText={extractUniqueTags(content.textMarkupValue)} />
                    }
                    {flags.pik1913TextEditorModule ? (
                        <HTMLEditMessage />
                    ) : (
                        <ParagraphButtonMenu
                            buttons={[
                                {
                                    icon: imageSources.ICONS.HTML_EDIT,
                                    text: 'Edit HTML',
                                    onClick: () => (F_EDIT_HTML ? this.setState({ showSourceEditor: true }) : null),
                                    dataTestId: 'edit-html',
                                    tooltipText: F_EDIT_HTML
                                        ? ''
                                        : 'Edit HTML for more customization. Learn more with a full product demo.',
                                    cursor: F_EDIT_HTML ? 'pointer' : 'not-allowed',
                                },
                            ]}
                            label="Advanced"
                            dataTestId="edit-html"
                        />
                    )}
                    <HorizontalRule styling={{ marginTop: 16 }} />
                    <Styled.LinkTipDiv data-test-id="text-HC-link">
                        <Styled.LinkIcon icon="external-link" />
                        <Styled.Link
                            href="https://support.staffbase.com/hc/en-us/articles/4412581467666"
                            rel="noopener noreferrer"
                            target="_blank"
                        >
                            Tips on text formatting
                        </Styled.Link>
                    </Styled.LinkTipDiv>
                </Styled.Row>
            </>
        );
    }
}

const mapStateToProps = (state) => {
    const integration = _get(state, 'session.integration', 'LOCALHOST');
    const isIntegrationsEnabled = _get(state, 'session.user.isIntegrationsEnabled', true);
    return {
        blocks: state.canvasBlocks.present,
        sessionFeatures: _get(state, 'session.features', {}),
        hasPersonalization:
            _get(state, 'session.user.features.EMAIL_DESIGNER_PERSONALIZATION', false) &&
            (integration === 'LOCALHOST' || integration === 'APP') &&
            !isIntegrationsEnabled,
    };
};

ParagraphSetting.defaultProps = {
    isTable: false,
}

ParagraphSetting.propTypes = {
    dispatch: PropTypes.func.isRequired,
    blocks: PropTypes.arrayOf(blockType).isRequired,
    sessionFeatures: PropTypes.object.isRequired,
    hasPersonalization: PropTypes.bool.isRequired,
    selectedElementData: PropTypes.shape({
        blockIndex: PropTypes.string.isRequired,
        columnIdx: PropTypes.string.isRequired,
        elmIdx: PropTypes.string.isRequired,
        content: elementContentType.isRequired,
    }).isRequired,
    flags: PropTypes.shape({
        pik1913TextEditorModule: PropTypes.bool.isRequired,
        ed484PersonalizationMsft: PropTypes.bool.isRequired,
    }).isRequired,
    isTable: PropTypes.bool,
};

export default withLDConsumer()(connect(mapStateToProps)(ParagraphSetting));
